export default "__VITE_ASSET__dcfcf94b__"